module.exports = __webpack_public_path__ + "static/VM-Default@2x-e6bedd4efdd354e8b2e32e6015793f04.png";